import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";

const AboutPage = lazy(() =>
  import("./pages/AboutPage").then((module) => ({ default: module.AboutPage }))
);
const CausesPage = lazy(() =>
  import("./pages/CausesPage").then((module) => ({
    default: module.CausesPage,
  }))
);
const HomePage = lazy(() =>
  import("./pages/HomePage").then((module) => ({ default: module.HomePage }))
);
const LaunchPage = lazy(() =>
  import("./pages/LaunchPage").then((module) => ({
    default: module.LaunchPage,
  }))
);
const LedgerPage = lazy(() =>
  import("./pages/LedgerPage").then((module) => ({
    default: module.LedgerPage,
  }))
);
const MarketPage = lazy(() =>
  import("./pages/MarketPage").then((module) => ({
    default: module.MarketPage,
  }))
);
const TokenPage = lazy(() =>
  import("./pages/TokenPage").then((module) => ({ default: module.TokenPage }))
);

function RouteLoading() {
  return (
    <div className="route-loading container" role="status">
      <span />
      <b>Opening Kyndo…</b>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<RouteLoading />}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="market" element={<MarketPage />} />
          <Route path="launch" element={<LaunchPage />} />
          <Route path="causes" element={<CausesPage />} />
          <Route path="ledger" element={<LedgerPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="token/:id" element={<TokenPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
